import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import { ErrorLogData } from "../../../models/ErrorLog";
import ModalConfirm from "../../ModalConfirm";
import { Pagination } from "../../Pagination";
import "./styles.scss";
import ErrorLogsListTopBar from "../ListTopBar";

interface IErrorLogsListProps {
  errorLogs: ErrorLogData[];
  filterFormData: any;
  totalCount: number;
  onChangeFilterFormData: (filterFormData: any) => void;
}

const ErrorLogsList: React.FC<IErrorLogsListProps> = ({
  errorLogs,
  filterFormData,
  totalCount,
  onChangeFilterFormData,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string, param?: any) =>
    _t(`errorLogsManagementPage.errorLogsList.${key}`, param);

  const [modalOpen, setModalOpen] = React.useState(false);
  const [modalDetails, setModalDetails] = React.useState<any>(null);

  return (
    <>
      <ErrorLogsListTopBar
        filterFormData={filterFormData}
        onChangeFilterFormData={onChangeFilterFormData}
      />
      <div className="table-data table-data-grid table-data-grid table-data-grid-pc-only error-logs-list">
        <div className="row-th">
          <div className="col-th">
            <div className="spacing">{t("id")}</div>
          </div>
          <div className="col-th">
            <div className="spacing">{t("type")}</div>
          </div>
          <div className="col-th">
            <div className="spacing">{t("status_code")}</div>
          </div>
          <div className="col-th">
            <div className="spacing">{t("details")}</div>
          </div>
          <div className="col-th">
            <div className="spacing">{t("created_at")}</div>
          </div>
          <div className="col-th">
            <div className="spacing">{t("created_by")}</div>
          </div>
        </div>
        {errorLogs &&
          errorLogs.length > 0 &&
          errorLogs.map((errorLog, idx) => (
            <div className="row-td" key={String(errorLog.id) || idx}>
              <div className="col-td">
                <div className="spacing">{String(errorLog.id)}</div>
              </div>
              <div className="col-td">
                <div className="spacing">{errorLog.type}</div>
              </div>
              <div className="col-td">
                <div className="spacing">{errorLog.status_code ?? "-"}</div>
              </div>
              <div className="col-td">
                <div
                  className="spacing details-cell"
                  onClick={() => {
                    setModalDetails(errorLog.details);
                    setModalOpen(true);
                  }}
                  title={
                    typeof errorLog.details === "string"
                      ? errorLog.details
                      : JSON.stringify(errorLog.details)
                  }
                >
                  {t("view_details")}
                </div>
              </div>
              <div className="col-td">
                <div className="spacing">
                  {errorLog.created_at
                    ? dayjs(errorLog.created_at).format("YYYY-MM-DD HH:mm:ss")
                    : "-"}
                </div>
              </div>
              <div className="col-td">
                <div className="spacing">
                  {errorLog.created_by ? String(errorLog.created_by) : "-"}
                </div>
              </div>
            </div>
          ))}
      </div>
      {errorLogs && errorLogs.length === 0 && (
        <div className="no-data">{t("no_data")}</div>
      )}
      {modalOpen && (
        <ModalConfirm
          title="details"
          cancelLabel={""}
          confirmLabel={"confirm"}
          onClose={() => setModalOpen(false)}
          onConfirm={() => setModalOpen(false)}
          color="blue"
          translate={true}
        >
          <div className="modal-details-json">
            {typeof modalDetails === "string"
              ? modalDetails
              : JSON.stringify(modalDetails, null, 2)}
          </div>
        </ModalConfirm>
      )}
      <Pagination
        filterFormData={filterFormData}
        totalRowsNumber={totalCount}
        onChangeFilterFormData={onChangeFilterFormData}
      />
    </>
  );
};

export default ErrorLogsList;
